import type {
  ControlNode as ControlNodeType,
  Port,
} from "../../../../util/src/blueprint/types.js";
import { PortHandle } from "../PortHandle.js";
import dico from "../../../../util/src/language/dico.js";
import React from "react";

export interface ControlMergeFlowsNodeProps {
  node: ControlNodeType;
  setPortsMap: (
    nodeId: string,
    portId: string,
    element: HTMLElement | null,
  ) => void;
  onPortMouseDown?: (nodeId: string, port: Port) => void;
  onPortMouseUp?: (nodeId: string, port: Port) => void;
  isPortConnected?: (nodeId: string, portId: string) => boolean;
}

const ControlMergeFlowsNodeComponent = ({
  node,
  setPortsMap,
  onPortMouseDown,
  onPortMouseUp,
  isPortConnected,
}: ControlMergeFlowsNodeProps) => {
  const behaviorDico = dico().behavior;
  const in1Port = node.ports.find((port) => port.id === "in1");
  const in2Port = node.ports.find((port) => port.id === "in2");
  const outPort = node.ports.find((port) => port.id === "out");
  if (!in1Port || !in2Port || !outPort) return null;

  return (
    <div
      style={{
        minWidth: 260,
        borderRadius: 8,
        overflow: "hidden",
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(200, 200, 200, 0.98) 100%)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        border: "1px solid #e5e7eb",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "4px 8px",
          fontSize: 12,
          fontWeight: 700,
          color: "#fff",
          background:
            "linear-gradient(180deg, #93c5fd 0%, #3b82f6 55%, #1d4ed8 100%)",
        }}
      >
        {behaviorDico.controls.mergeFlows}
      </div>
      <div style={{ display: "flex", alignItems: "stretch", padding: "6px 0" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flex: 1,
          }}
        >
          <PortHandle
            node={node}
            port={in1Port}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, in1Port)}
            onMouseUp={() => onPortMouseUp?.(node.id, in1Port)}
            isConnected={isPortConnected?.(node.id, in1Port.id) ?? false}
          />
          <PortHandle
            node={node}
            port={in2Port}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, in2Port)}
            onMouseUp={() => onPortMouseUp?.(node.id, in2Port)}
            isConnected={isPortConnected?.(node.id, in2Port.id) ?? false}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <PortHandle
            node={node}
            port={outPort}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, outPort)}
            onMouseUp={() => onPortMouseUp?.(node.id, outPort)}
            isConnected={isPortConnected?.(node.id, outPort.id) ?? false}
          />
        </div>
      </div>
    </div>
  );
};

export const ControlMergeFlowsNode = React.memo(ControlMergeFlowsNodeComponent);
